<template>
    <div>
      <Tables ref="tableOcorrenciaTecnicoEngenheiro"
                  :columns= colum
                  :showSearch="false"
                  :showPrint="false"
                  :newHeaderStatus="true"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoadTable(tipo)"
                  style="font-family: 'Segoe UI'"
                  >
                  <tr v-for="(obj,index) in dados" :key="index">
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.nome"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.dataCriacao"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.dataNascimentoFormatada"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.telefone"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.cpf"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.email"></TableColumn>

                            <TableColumn :IsText="false"
                                        :IsActiveButton="true"
                                        :HasChange="true"
                                        :newEditGama="true"
                                        :HasDelete="true"
                                        v-on:Edit="popUpEdicao(obj)"
                                        v-on:Delete="popUpExclusao(obj)"></TableColumn>
                  </tr>
                  <template #ButtonsAprova>
                  <div class="buttons-table-action">
                      <button class="btn-generate-lote-template-qma" @click="popUpAdd">+ ADICIONAR</button>
                  </div>
                  </template>
      </Tables>

      <b-modal ref="add-cadastro"
            size="md"
            centered
            id="add-edit-cadastro"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <div class="header-title">{{tipo === 0 && edicao === false ? 'ADICIONAR ENGENHEIRO' : tipo === 1 && edicao === false ? 'ADICIONAR TÉCNICO' : tipo === 0 && edicao === true ? 'EDITAR ENGENHEIRO' :  'EDITAR TÉCNICO'}}</div>
            </template>

            <div class="container-add-itens">
                <b-form-group
                id="input-group-name-accountid"
                label="Nome"
                label-for="input-name-accountid"
                >
                <b-form-input
                class="input"
                id="name-usuario"
                name="name-usuario"
                v-validate="{ alpha_spaces: true, required: true }"
                :state="validateState('name-usuario')"
                type="text"
                v-model="additem.nome"
                placeholder="Nome"
                ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-name-accountid"
                    label="CPF"
                    label-for="input-name-accountid"
                >
                <b-form-input
                    class="input"
                    id="cpf-tec-eng"
                    name="cpf-tec-eng"
                    v-validate="{ required: true, numeric: false, length:14}"
                    :state="validateState('cpf-tec-eng')"
                    type="text"
                    v-model="additem.cpf"
                    placeholder="000.000.000-00"
                    v-mask="['###.###.###-##']"
                ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-name-accountid"
                    label="Email"
                    label-for="input-name-accountid"
                >
                <b-form-input
                    class="input"
                    id="email-usuario"
                    name="email-usuario"
                    v-validate="{required: true, email: true }"
                    :state="validateState('email-usuario')"
                    type="email"
                    v-model="additem.email"
                    placeholder="Email"
                ></b-form-input>
                </b-form-group>

                <b-form-group
                id="input-group-name-accountid"
                label="Telefone"
                label-for="input-name-accountid"
                >
                <b-form-input
                    class="input"
                    id="telefone-usuario"
                    name="telefone-usuario"
                    v-validate="{ required: true, numeric: false, length: 15 }"
                    :state="validateState('telefone-usuario')"
                    type="text"
                    v-model="additem.telefone"
                    placeholder="(__) ____-____"
                    v-mask="['(##) #####-####']"
                ></b-form-input>
                </b-form-group>

             <b-form-group
                id="input-group-name-accountid"
                label="Data de Nascimento"
                label-for="input-name-accountid"
              >
              <b-form-input
                class="input"
                id="nascimento-usuario"
                name="nascimento-usuario"
                v-validate="{  required: true  }"
                :state="validateState('nascimento-usuario')"
                type="date"
                v-model="additem.datanascimento"
              ></b-form-input>
              </b-form-group>
            </div>

            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopAddEdicao">Cancelar</button>
                <button v-if="tipo === 1 && edicao === false" class="button-save" @click="addTecnico">Salvar</button>
                <button v-if="tipo === 1 && edicao === true" class="button-save" @click="UpdateTecnico">Editar</button>
                <button v-if="tipo === 0 && edicao === false" class="button-save" @click="addEngenheiro">Salvar</button>
                <button v-if="tipo === 0 && edicao === true"  class="button-save" @click="UpdateEngenheiro">Editar</button>
            </div>
        </b-modal>

        <b-modal ref="exclusao"
            size="md"
            centered
            id="exclusao"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <div class="header-title">{{tipo === 0 ? 'EXCLUIR ENGENHEIRO' : 'EXCLUIR TÉCNICO'}}</div>
            </template>

            <div class="icon-lixo"><i class="fas fa-trash" style="color: #b60000; font-size: 55px; text-align: center; margin-bottom: 1rem;"></i></div>

            <div class="font">Deseja proseguir com a exclusão {{tipo === 0 ? 'da engenheiro' : 'do técnico'}} <strong style="font: bold;">{{ usuario }}</strong>?</div>

            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopExclusao">Cancelar</button>
                <button v-if="categoria === 1"  class="button-save" @click="DeleteTecnico">Excluir</button>
                <button v-if="categoria === 0"  class="button-save" @click="DeleteEngenheiro">Excluir</button>
            </div>
        </b-modal>

     </div>
</template>

<script>
import table from './table'
export default table
</script>

  <style scoped>
  .fontePopUp {
    font-family: 'Segoe UI';
    font-size: 14px;
    font-weight: bold;
  }
  .icon-lixo{
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .font {
    width: 100%;
    line-height: 1.5rem ;
    text-align: center;
    font-family: 'Segoe UI';
    font-size: 18px;
    color: #505050;
  }
  .container-buttons-form{
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }
  .icone-alerta {
    display: flex;
    margin: 1rem 0 1rem 0;
    justify-content: center;
    font-size: 55px;
    color: darkgreen;
  }
  .font-clone{
    display: flex;
    justify-content: center;
    color: rgb(128, 128, 128);
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
  #impor-ex-price{
    display: none;
  }
   .novoTemplate {
      padding: 0.5rem 3rem 0.5rem 3rem
   }
   .descricaoArea{
      width: 100%;
      height: 5rem;
      border-color: #b3b3b3;
      border-radius: 1px;
   }
   .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .btn-generate-lote-template-qma {
      height: 2rem;
      padding: 0 1rem;
      background: #008144;
      color: white;
      border-radius: 4px;
      width: fit-content;
      border: none;
      font-size: 10px;
  }
  .btn-generate-lote-template-qma:hover{
      background: #024d2a;
      width: fit-content;
  }
  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
  .container-add-itens{
      width: 100%;
      height: fit-content;
      overflow: auto;
  }
  .container-add-itens::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 10px;
  }
  .container-add-itens::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
      border-radius: 10px;
  }
  .container-add-itens::-webkit-scrollbar-thumb {
      background: #dad7d7;
      border-radius: 10px;
  }
  .input-descricao{
      width: 100%;
      margin-top: 0.5rem;
      height: 2rem;
      color: #585858;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 17px;
      margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/occurrenceMaintenance/components/tabla/table.vue